import { ribbonRoses, realFlowers, corsages, boobouquet } from '../data/products';
import { useState } from 'react';

const ProductSection = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  // Add these helper functions
  const formatAUD = (value) =>
    typeof value === 'number' ? `$${value.toFixed(2)}` : value;

  const getSalePrice = (price, promoPercent) => {
    if (typeof price !== 'number' || !promoPercent) return null;
    return Number((price * (1 - promoPercent / 100)).toFixed(2));
  };

  const getFilteredProducts = () => {
    switch (selectedCategory) {
      case 'ribbon':
        return ribbonRoses;
      case 'real':
        return realFlowers;
      case 'corsage':
        return corsages;
      case 'boobouquet':  // ✅ Add this
        return boobouquet;  // ✅ Filter for BooBouquets
      default:
        return [...ribbonRoses, ...realFlowers, ...corsages, ...boobouquet];
    }
  };

  const filteredProducts = getFilteredProducts();

  return (
    <section className="py-0">
      <div className="w-900 mx-auto px-10">
        <div className="text-center mb-8 md:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-6xl lg:text-6xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Our Collection
          </h2>
          <p className="text-xl text-gray-600">
            Handcrafted ribbon roses and fresh flower arrangements
          </p>
        </div>

        {/* Filter Buttons */}
<div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-8 md:mb-12 px-4">
  <button
    onClick={() => setSelectedCategory('all')}
    className={`px-4 md:px-8 py-2 md:py-3 rounded-full text-sm md:text-lg font-semibold transition-all duration-300 whitespace-nowrap ${
      selectedCategory === 'all'
        ? 'bg-rose-600 text-white shadow-lg scale-105'
        : 'bg-white text-gray-700 hover:bg-gray-100'
    }`}
  >
    All Products
  </button>
  <button
    onClick={() => setSelectedCategory('ribbon')}
    className={`px-4 md:px-8 py-2 md:py-3 rounded-full text-sm md:text-lg font-semibold transition-all duration-300 whitespace-nowrap ${
      selectedCategory === 'ribbon'
        ? 'bg-rose-600 text-white shadow-lg scale-105'
        : 'bg-white text-gray-700 hover:bg-gray-100'
    }`}
  >
    Ribbon Roses
  </button>
  <button
    onClick={() => setSelectedCategory('real')}
    className={`px-4 md:px-8 py-2 md:py-3 rounded-full text-sm md:text-lg font-semibold transition-all duration-300 whitespace-nowrap ${
      selectedCategory === 'real'
        ? 'bg-rose-600 text-white shadow-lg scale-105'
        : 'bg-white text-gray-700 hover:bg-gray-100'
    }`}
  >
    Fresh Flowers
  </button>
  <button
    onClick={() => setSelectedCategory('corsage')}
    className={`px-4 md:px-8 py-2 md:py-3 rounded-full text-sm md:text-lg font-semibold transition-all duration-300 whitespace-nowrap ${
      selectedCategory === 'corsage'
        ? 'bg-rose-600 text-white shadow-lg scale-105'
        : 'bg-white text-gray-700 hover:bg-gray-100'
    }`}
  >
    Corsages & Boutonnieres
  </button>
  
  <button
  onClick={() => setSelectedCategory('boobouquet')}
  className={`px-4 md:px-8 py-2 md:py-3 rounded-full text-sm md:text-lg font-semibold transition-all duration-300 whitespace-nowrap ${
    selectedCategory === 'boobouquet'
      ? 'bg-rose-600 text-white shadow-lg scale-105'
      : 'bg-white text-gray-700 hover:bg-gray-100'
  }`}
>
  BooBouquets
</button>
  

  
</div>

        {/* Products Grid */}
        <div
  id="boutonneries"
  className="
    grid grid-cols-2
    sm:grid-cols-3
    md:grid-cols-3
    lg:grid-cols-3
    gap-3 sm:gap-4 md:gap-6 lg:gap-12
    px-3 sm:px-4 md:px-6
  "
>
   {filteredProducts.map((product) => (
    <div
      key={product.id}
      className="group bg-white overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
    >
      {/* Product Image */}
      <div className="relative h-40 sm:h-48 md:h-64 lg:h-96 overflow-hidden">
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
        />
        {product.soldOut && (
    <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center">
      <span className="bg-white text-gray-800 font-bold text-xs md:text-sm px-3 py-1.5 rounded-full tracking-widest uppercase">
        Sold Out
      </span>
    </div>
  )}
      </div>

      {/* Product Info */}
      <div className="p-2 md:p-6 lg:p-6">
        {/* Category Badge */}
        <span className="inline-block bg-rose-100 text-rose-700 px-2 md:px-4 py-0.5 md:py-1 rounded-full text-[10px] md:text-sm font-semibold mb-2 md:mb-3">
          {product.category === 'ribbon' ? 'Ribbon Rose' : 
           product.category === 'real' ? 'Fresh Flowers' :
           product.category === 'corsage' ? 'Corsage & Boutonniere' : 'BooBouquet'}
        </span>

        {/* Product Name */}
        <h3 className="text-sm md:text-lg lg:text-3xl font-bold text-gray-900 mb-2 md:mb-2 lg:mb-3 line-clamp-2 leading-tight">
          {product.name}
        </h3>

        {/* Price and Button */}
        <div className="flex flex-col gap-1.5 md:gap-5">
                  {/* Price - Now with discount logic */}
                  {product.promoPercent ? (
                    <div className="flex items-baseline gap-2 flex-wrap">
                      <span className="text-[10px] md:text-xs font-bold bg-rose-600 text-white px-2 py-0.5 rounded-full">
                        {product.promoPercent}% OFF
                      </span>

                      <span className="text-sm md:text-lg lg:text-xl text-gray-400 line-through font-semibold">
                        {formatAUD(product.price)}
                      </span>

                      <span className="text-base md:text-xl lg:text-2xl font-bold text-rose-600">
                        {formatAUD(getSalePrice(product.price, product.promoPercent))}
                      </span>
                    </div>
                  ) : (
                    <span className="text-base md:text-xl lg:text-2xl font-bold text-rose-600">
                      {formatAUD(product.price)}
                    </span>
                  )}
          
          {/* Button */}
          <button
            onClick={() => window.location.href = `/product/${product.id}`}
            className="w-full bg-[#EFBBCC] hover:bg-[#f1adc3] text-white px-2 md:px-6 lg:px-6 py-1.5 md:py-1.5 lg:py-1.5 rounded-lg md:rounded-xl text-[11px] md:text-sm lg:text-sm font-bold transition-all duration-300 hover:scale-105 shadow-md"
          >
            View
          </button>
        </div>
      </div>
    </div>
  ))}
</div>
      </div>
    </section>
  );
};

export default ProductSection;